var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Options, Vue, setup } from "vue-class-component";
import { formatTime } from "@/utils";
import { MSG_TYPE, MSG_OPT_TYPE } from "@/const";
import { ref } from "vue";
import { Icon, Popover, Tag } from "vant";
import websdk from "easemob-websdk";
var Props = /** @class */ (function () {
    function Props() {
    }
    return Props;
}());
var MessageRight = /** @class */ (function (_super) {
    __extends(MessageRight, _super);
    function MessageRight() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rightMsg = setup(function () {
            var intervalId;
            var formatUrl = function (url) {
                //@ts-ignore
                if (window.localStorage.getItem("isAuthFile") === "true") {
                    //@ts-ignore
                    return url + "&auth=" + window.localStorage.getItem("token");
                }
                return url;
            };
            var previewImg = function (url) {
                _this.$emit("previewImg", formatUrl(url));
            };
            var downloadAttach = function (url) {
                var fileUrl = url;
                //@ts-ignore
                if (window.localStorage.getItem("isAuthFile") === "true") {
                    //@ts-ignore
                    fileUrl = url + "&auth=" + window.localStorage.getItem("token");
                }
                //@ts-ignore
                var filename = _this.msg.filename;
                websdk.utils.download({
                    url: fileUrl,
                    onFileDownloadComplete: function (data) {
                        console.log("下载成功", data);
                        var href = window.URL.createObjectURL(data);
                        var link = document.createElement('a');
                        link.href = href;
                        link.download = filename;
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(href); // 释放内存  
                    },
                    onFileDownloadError: function (error) {
                        console.log("下载失败", error);
                    }
                });
            };
            var uid = localStorage.getItem("uid");
            var times = ref(0); // 加载视频重试次数
            var isShowMenu = ref(false);
            var actions = [
                {
                    text: MSG_OPT_TYPE.pin
                },
                { text: MSG_OPT_TYPE.recall }
            ];
            actions.push({ text: MSG_OPT_TYPE.modify });
            var showMenu = function () {
                clearInterval(intervalId);
                intervalId = setTimeout(function () {
                    isShowMenu.value = true;
                }, 300);
            };
            var end = function () {
                clearInterval(intervalId);
            };
            var getCombineMsg = function (msg) {
                _this.$emit("previewCombineMsg", msg);
            };
            var onSelect = function (action) {
                if (action.text === MSG_OPT_TYPE.recall) {
                    _this.$emit("recallMessage");
                }
                else if (action.text === MSG_OPT_TYPE.modify) {
                    _this.$emit("modifyMessage");
                }
                else if (action.text === MSG_OPT_TYPE.pin) {
                    _this.$emit("pinMessage");
                }
            };
            var onVideoError = function (id, src) {
                var timerId = 0;
                timerId && clearInterval(timerId);
                // 加载失败进行重试
                if (times.value < 5) {
                    times.value++;
                    timerId = setTimeout(function () {
                        var video = document.getElementById(id);
                        video.setAttribute("src", src);
                    }, 1000);
                }
            };
            return {
                actions: actions,
                msgType: MSG_TYPE,
                isShowMenu: isShowMenu,
                uid: uid,
                formatTime: formatTime,
                onSelect: onSelect,
                previewImg: previewImg,
                showMenu: showMenu,
                end: end,
                getCombineMsg: getCombineMsg,
                downloadAttach: downloadAttach,
                formatUrl: formatUrl,
                onVideoError: onVideoError
            };
        });
        return _this;
    }
    MessageRight = __decorate([
        Options({
            props: {
                msg: {
                    default: function () {
                        return {};
                    }
                },
                timestamp: 0,
                isPinned: false
            },
            components: {
                Icon: Icon,
                Popover: Popover,
                Tag: Tag
            },
            emits: [
                "previewImg",
                "recallMessage",
                "modifyMessage",
                "previewCombineMsg",
                "pinMessage"
            ]
        })
    ], MessageRight);
    return MessageRight;
}(Vue.with(Props)));
export default MessageRight;
